export default __webpack_public_path__ + "static/media/url_monitor.073570d3.md";